// estimatePayoutCents mirrors models.ComputeSettlement for a stake that has
// not been placed yet: add it to the staked pool, take the market's cut off
// that, add the house seed (rake-free, inside poolCents), then pay the
// stake's share of its outcome. Integer cents with the server's floor
// division, so the two agree up to the feed's cache window.
// Returns null when any figure would mislead: an empty pool, or no credits on
// any other producer, where settling now would refund every stake
// (models.ShouldVoid: only one outcome attracted stakes).
export function estimatePayoutCents(
  poolCents: number,
  takeBps: number,
  outcomeStakedCents: number,
  stakeCents: number,
  seedCents = 0,
): number | null {
  if (poolCents <= 0 || stakeCents <= 0) return null;
  const staked = poolCents - seedCents;
  if (staked - outcomeStakedCents <= 0) return null;
  const pool = staked + stakeCents;
  const take = Math.floor((pool * takeBps) / 10_000);
  const bettorPool = pool - take + seedCents;
  return Math.floor((bettorPool * stakeCents) / (outcomeStakedCents + stakeCents));
}

// noRivalBacked reports whether a pick has nobody backing any other producer
// yet, the case estimatePayoutCents refuses to price.
export function noRivalBacked(poolCents: number, outcomeStakedCents: number, seedCents = 0): boolean {
  return poolCents - seedCents - outcomeStakedCents <= 0;
}

// parseCredits turns the slip's text into cents, or null when the entry is
// not a positive amount with at most two decimals.
export function parseCredits(text: string): number | null {
  const trimmed = text.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return null;
  const cents = Math.round(Number(trimmed) * 100);
  return cents > 0 ? cents : null;
}
